import Vue from 'vue'
import App from './App.vue'
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-sugar.css';
import cnzzStat from '@jin10/utils/lib/cnzzStat'
import IscrollView from '@/plugins/iscroll'

import "../../styles/index.scss"

window._czc = window._czc || []

if (location.protocol === 'https:' && location.href.indexOf('test/rank/') === -1) {
  cnzzStat()
}

Vue.use(VueToast);
Vue.config.productionTip = false

Vue.prototype.$bus = new Vue()

Vue.component('IscrollView', IscrollView)

new Vue({
  render: h => h(App),
}).$mount('#app')
